import type { Apartment } from "@/models/responses";

// Date-only day number from UTC components. quicktype Dates are UTC-midnight,
// so reading UTC (not local) Y/M/D avoids the UTC off-by-one in negative
// timezones. See gotcha-date-only-string-utc-offbyone.
const toDayNum = (d: Date): number =>
    d.getUTCFullYear() * 10000 + (d.getUTCMonth() + 1) * 100 + d.getUTCDate();

export const isOperationalInWindow = (
    apt: Pick<Apartment, "dateAdded" | "dateRemoved">,
    start: Date,
    end: Date,
): boolean =>
    toDayNum(apt.dateAdded) <= toDayNum(end) &&
    // Removal side is HALF-OPEN: dateRemoved is the first non-operating day
    // (matches isActiveNow's `dateRemoved > today` in useApartmentFilters.ts).
    // An apt removed exactly on `start` did NOT operate during the window.
    // The dateAdded <= end side stays inclusive.
    (apt.dateRemoved == null || toDayNum(apt.dateRemoved) > toDayNum(start));

export const operationalPropertyCount = (
    apartments: ReadonlyArray<Pick<Apartment, "dateAdded" | "dateRemoved">>,
    start: Date,
    end: Date,
): number => apartments.filter((a) => isOperationalInWindow(a, start, end)).length;
